import React from 'react';
import { useAuth } from './../components/AuthProvider'; // Adjust path to your AuthContext file

export default function AdminNavigation({ tabs = [], currentTab = '', onSelectTab = () => {} }) {
  const { user, logout } = useAuth();

  // If auth context isn't fully loaded yet or user is missing, don't crash
  if (!user) return null;

  return (
    <nav className="nav-sidebar-container">
      {/* 1. User Profile Box */}
      <div className="nav-profile-card">
        {user.picture && (
          <img 
            src={user.picture} 
            alt={user.name || 'Admin'} 
            className="nav-profile-avatar"
            referrerPolicy="no-referrer" // Prevents Google from blocking image loads across domains
          />
        )}
        <div className="nav-profile-details">
          <h4 className="nav-profile-name">{user.name || 'Administrator'}</h4>
          <span className="nav-profile-email">{user.email}</span>
          <span className="nav-profile-badge">{user.role || 'Admin'}</span>
        </div>
      </div>

      {tabs.length > 0 && (
        <>
          <hr className="nav-divider" />
          <div className="nav-section-title">Modules</div>
          <div className="nav-module-list">
            {tabs.map((tab) => (
              <button
                type="button"
                key={tab.id}
                className={`nav-module-button ${currentTab === tab.id ? 'active' : ''}`}
                onClick={() => onSelectTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </>
      )}

      <hr className="nav-divider" />

      {/* 2. Navigation Utilities Panel */}
      <div className="nav-actions">
        <button onClick={logout} className="nav-logout-button">
          {/* Inline SVG Logout icon */}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Log Out
        </button>
      </div>
    </nav>
  );
}